import * as React from 'react';
import { Prompt } from 'react-router';
import { Link } from 'react-router-dom';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withProps } from 'recompose';
import { reduxForm, FieldArray } from 'redux-form';
import DeleteIcon from 'material-ui/svg-icons/content/clear';
import { DateField, Date as DateInput, RemoteAutoComplete, RemoteAutoCompleteField } from '@components/form';

import * as T from '@modules/hr-shift-cycles/_shiftCyclesTypes';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { getShiftCycle } from '@modules/hr-shift-cycles/_shiftCyclesActions';
import { required, validateTwoDates } from '@utils/validators';
import { IconButton } from 'material-ui';

const linkBack = '/hr/shifts/cycles';

const enhance = compose<T.ShiftCyclesFormProps, T.ShiftCyclesFormProps>(
  EntityDetailEnhancer<T.ShiftCyclesEnhancerProps<T.ShiftCycle>, T.ShiftCycle>({
    getEntity: getShiftCycle,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [{ label: 'Směny', to: linkBack }, { label: get(entity, 'name', 'Nový cyklus směna') }]),
  withProps<{}, T.ShiftCyclesForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {}
  })),
  reduxForm({
    form: 'shiftsForm',
    validate: validateTwoDates
  })
);

const renderEmployee = ({ fields, meta: { error } }) => (
  <>
    {fields.map((employee, index) => (
      <Row key={`employee${index}`} style={{ marginBottom: 20 }}>
        <Col md={12}>
          <div style={{ display: 'flex' }} key={index}>
            <div>
              <IconButton
                tooltipPosition="top-center"
                onClick={() => fields.remove(index)}
                tooltip="Vymazat"
                style={{ width: 36, height: 36, padding: 0, marginTop: 32 }}
              >
                <DeleteIcon />
              </IconButton>
            </div>
            <div key={index} style={{ width: 200, marginRight: 5 }}>
              <RemoteAutoCompleteField
                id="type"
                caching={true}
                name={`${employee}.id`}
                label={`Zaměstnanec ${index + 1} *`}
                fullWidth={true}
                component={RemoteAutoComplete}
                url="/metropolis/api/hr/employees"
                labelFunction={o => (o ? `${get(o, 'firstName')} ${get(o, 'lastName')}` : undefined)}
                valueFunction={o => get(o, 'id')}
                validate={[required]}
                arrowstyle={{
                  color: '#e1e0e1',
                  position: 'absolute',
                  right: 0,
                  top: 32
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
    ))}
    {error && <div className="error">{error}</div>}
    <div>
      <Button
        label="Přidat zaměstnance"
        primary={true}
        style={{ margin: '16px 0 16px 16px' }}
        onClick={() => fields.push()}
      />
    </div>
  </>
);

const View: React.SFC<T.ShiftCyclesFormProps> = ({ selectedCalendar, change, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={4} xl={2} className="with-right-divider">
              <Row>
                <Col md={12}>
                  <h4>Základní údaje</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RemoteAutoCompleteField
                    id="type"
                    caching={true}
                    name="label"
                    label="Název *"
                    fullWidth={true}
                    component={RemoteAutoComplete}
                    url="/metropolis/api/hr/workplan/shift"
                    labelFunction={o => get(o, 'name')}
                    valueFunction={o => get(o, 'name')}
                    validate={[required]}
                    arrowstyle={{
                      color: '#e1e0e1',
                      position: 'absolute',
                      right: 0,
                      top: 32
                    }}
                  />
                </Col>
                <Col md={12}>
                  <RemoteAutoCompleteField
                    component={RemoteAutoComplete}
                    name="shift"
                    label="Směna"
                    url={`/metropolis/api/hr/workplan/shift`}
                    labelFunction={o => get(o, 'name')}
                    valueFunction={o => o}
                    fullWidth={true}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={4} xl={2} className="with-right-divider">
              <Row>
                <Col md={12}>
                  <h4>Omezení</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <DateField
                    component={DateInput}
                    id="from"
                    name="from"
                    dateOnly={false}
                    validate={[required]}
                    label="Od *"
                    allowFuture={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <DateField
                    component={DateInput}
                    id="to"
                    name="to"
                    dateOnly={false}
                    validate={[required]}
                    label="Do *"
                    allowFuture={true}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={4} xl={2} className="with-right-divider">
              <Row>
                <Col md={12}>
                  <h4>Zaměstnanci</h4>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FieldArray<any> name="employees" component={renderEmployee} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={linkBack} />} />
      </Card>
    </form>
  </div>
);

export const ShiftsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-shift-cycles/ShiftCyclesForm.tsx